import { useApi } from '@pidz/api';

const api = useApi();

export const documentService = {
  downloadDocument: async (id: number): Promise<{name: string, data: string}> => api.jsonrpc({
    url: 'document:downloadDocument',
    params: { id }
  }),
};